import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify'; // Import react-toastify
import 'react-toastify/dist/ReactToastify.css'; // Import react-toastify styles
import loginImage01 from "../../assets/images/registration/registration-steps-image-01.jpg";
import loginImage02 from "../../assets/images/registration/registration-steps-image-03.jpg";
import loginImage03 from "../../assets/images/registration/registration-steps-image-04.jpg";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Pronouns from './Pronouns';
import Relationship from './Relationship';
import HealthPlan from './Healthplans';
import Gender from './Gender';
import FamilyBuildingGoals from './Family_Building_Goals';
import FamilyBuildingJourney from './Family_Building_Journey';
import axios from 'axios';
import { useNavigate, useLocation } from "react-router-dom";
import { Endpoints } from "../../Global/Endpoints";
import Cookies from "universal-cookie";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../assets/images/logo-win.svg";
import highmarkLogo from "../../assets/images/highmark/ffb-logo.jpg";
import { setFullyVerified } from '../../Redux/verificationReducer';
import { updateEmail } from '../../Redux/emailReducer';
import { setRegistrationData,setCreateAccountPasswordData } from '../../Redux/registrationReducer';
import { updateUserData } from '../../Redux/userReducer';
import { useTranslation } from 'react-i18next';
import PregnancyDueDate from "./PregnancyDueDate";
import PrepregnancyDetails from "./prePregnancyDetails";
import { error } from "pdf-lib";
import HowToGetPregnant from "./How_to_Get_Pregnant";
import WelcomeKit from "../WINBenifits/WelcomeKit";

const HealthProfileMultiStageForm = ({ isEditMode }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const cookies = new Cookies();
    const [step, setStep] = useState(1);
    const [isVerified, setIsVerified] = useState(false); // Track verification status
    const isPartiallyVerified = useSelector((state) => state.verification.isPartiallyVerified); // Get partial verification state
    const isLoggedIn = useSelector((state) => state.login.isAuthenticated);  
    const [verifyData, setVerifyData] = useState({});
    const [editUserData, setEditUserData] = useState({});
    const contract = useSelector((state) => state.userData);
    const initialPassword = useSelector((state) => state.registration.createaccountpassword);
    const [isSubmitting, setIsSubmitting] = useState(false); // Track submission state
    const [errors, setErrors] = useState({});
    const isSSO = useSelector((state) => state.sso.isSSO); 
    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";
    const ssoId = useSelector((state) => state.ssoQueryParamsDetails.ssoId);
    const ssoParams = useSelector((state) => state.ssoQueryParamsDetails.ssoParams);
    const isJourneyChangeEdit = isEditMode && location?.state?.journeyChange === true;
    const [formData, setFormData] = useState({
        emailId: verifyData.EmailID,
        pronouns: '',
        relationshipStatus: '',
        healthPlans: [],
        assignedSex: '',
        familyGoals: [],
        journeyStage: '',
        password: verifyData.PWD,
        PregnancyDueDate:"",
        WinCentivekit:"N",
        WinCentiveAddress:"",
        NoDueDateFlag:"",
        IsPregnant:"",
        Weight:"",
        TypeofWeigh:"",
        Height:"",
        TypeofHeight:"",
        Ava:"",
        Mira:"",
        WINFertilityTracker:"",
        Natural:"",
        FertilityTreatment:"",
        DeviceType:""
    });
   useEffect(() => {
        const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
        if (myCarousel) {
            new window.bootstrap.Carousel(myCarousel, {
                interval: 2000,
            });
        }
        
    }, []);
  useEffect(() => {
    if (location.state?.isNavigatingFromCompany) {
      blockOnBackNavigation();
    }
  }, [location.state?.isNavigatingFromCompany]);

const blockOnBackNavigation = () => {
  const handlePopState = () => {
    window.history.pushState(null, "", window.location.href);
  };

  window.history.pushState(null, "", window.location.href);
  window.addEventListener("popstate", handlePopState);

  // Return cleanup
  return () => {
    window.removeEventListener("popstate", handlePopState);
  };
};
    useEffect(() => {
        if (!isPartiallyVerified && isEditMode === false) {
            navigate("/login");
        } else if (location.state && !isEditMode) {
            if(location.state?.isNavigatingFromCompany)
          {
            setVerifyData(location.state.updatedFormData);
        } 
        else{
          setVerifyData(location.state.updatedFormData)
        }
        } 
        else if(location.state?.journeyChange && isEditMode)
        {
            fetchExistingProfileData();
            setStep(4);
        }
        else if (isEditMode) {
            fetchExistingProfileData();
        }
    }, [isPartiallyVerified, location.state, navigate, verifyData]);

    const validateStep = () => {
        let newErrors = {};
        if (step === 1 && !formData.pronouns) newErrors.pronouns = "Please select your pronouns.";
        if (step === 2 && !formData.relationshipStatus) newErrors.relationshipStatus = "Please select your relationship status.";
        if (step === 3 && !formData.assignedSex) newErrors.assignedSex = "Please select your gender.";
        if (step === 4 && formData.healthPlans.length===0) newErrors.healthPlans = "Please select at least one health plan.";
        if (step === 5 && formData.familyGoals.length === 0) newErrors.familyGoals = "Please select at least one family goal.";
        if (step === 6 && !formData.journeyStage) newErrors.journeyStage = "Please select your journey stage.";
        if (step === 8) {
            if (!formData.PregnancyDueDate && !formData.LastMenstrualPeriodDate) 
                newErrors.pregnancyDueDate = "Please select a Due Date or Last Menstruation Date.";
            if(formData.IsPregnant=="")
            { 
                 newErrors.pregnancyType="Please select atleast one option."

            }}
            if(step===9)
            {
 if (formData.enrolled === "Y") {
                if (!formData.addressOption) {
                    newErrors.addressOption = "Please select an address option.";
                }
    
                if (formData.addressOption === "No" && !formData.WinCentiveAddress && !formData.WinCentiveAddress!="") {
                    newErrors.WinCentiveAddress = "Address is required if 'No' is selected.";
                }
            }
            }
           
        
        // if(step===9)
        // {
        //   if(formData.Height=="") 
        //   {
        //     newErrors.Height="Height is required."
        //   }
        //   if(formData.Weight =="")
        //   {
        //     newErrors.Weight="Weight is required."
        //   }
        // }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (value) {
                delete newErrors[name]; // Remove the error from state
            }
           
            return newErrors;
        });
    };

    const nextStep = () => {
        if(validateStep())
        {
        if (step === 4 && formData.healthPlans === 'I want family-building support') {
            setStep(5);
        } else if((step === 4 &&  formData.healthPlans===t('pregnancysupport')))
            {
              if(formData.entrolled==="Y")
              {
setStep(8);
              }
              else{
              setStep(7);
              }
                
            }
        else if (step === 4) {
            setStep(6);
        } 
         else if(step===9)
        {
            setStep(10);
        }
            else {
            setStep(step + 1);
        }
    }
    };
    const prevStep = () => {   
        if (location.state?.journeyChange && step === 4) {
            navigate("/home");  // Redirect back to home if journeyChange is true
        } else if (step === 7) {
            setStep(4);  // Ensure step 7 goes back to step 4 (Health Plans)
        } 
        else if(step===10)
        {
          if(formData.entrolled==="Y")
          {
            setStep(9);
          } 
          else{
            setStep(8);
          }
        }
        else {
            setStep(step - 1);  // Default behavior for normal navigation
        }
    };
    const getTotalSteps = () => {
        const selectedPlan = Array.isArray(formData.healthPlans)
          ? formData.healthPlans[0]
          : formData.healthPlans;
      
        // 1. Journey edit mode
      if (isJourneyChangeEdit) {
        if (selectedPlan === t('pregnancysupport')) {
          return 4;
        } else if (selectedPlan === 'I want family-building support') {
          return 3;
        } else {
          return 1;
        }
      }
      
        // 2. Edit mode
        if (isEditMode) {
          if (selectedPlan === t('pregnancysupport')) return 7;
          if (selectedPlan === 'I want family-building support') return 6;
          return 4;
        }
      
        // 3. Non-edit (new registration)
        if (selectedPlan === 'I want family-building support') return 6;
        if (selectedPlan === t('pregnancysupport')) return 7;
      
        return 4; // fallback for others
      };
      
      
      
      
      const getCurrentStepNumber = () => {
        const selectedPlan = Array.isArray(formData.healthPlans) ? formData.healthPlans[0] : formData.healthPlans;
      
        if (!isJourneyChangeEdit)
            {
                if (selectedPlan === t('pregnancysupport'))
                {
                    if (step === 4) return 4;
          if (step === 7) return 5;
          if (step === 8) return 6;
          if(formData.entrolled==="Y")
          {
 if (step === 9) return 7;
           if (step === 10) return 8;

          }
          else{
             if (step === 10) return 7;
          }
         
                }
       return step;

            }
        // Edit starts from step 4
        if (selectedPlan === 'I want family-building support') {
          // Steps: 4 → 1, 5 → 2, 6 → 3
          return step - 3;
        }
      
        if (selectedPlan === t('pregnancysupport')) {
          // Steps: 4 → 1, 7 → 2, 8 → 3
          if (step === 4) return 1;
          if (step === 7) return 2;
          if (step === 8) return 3;
          if (step === 9) return 4;
           if (step === 10) return 4;
        }
      
        // Default journeyChangeEdit (e.g., step 4 only)
        return 1;
      };
      
      
      
      
    
    const fetchExistingProfileData = async () => {
        setEditUserData(contract.userData);
        setFormData((prevData) => ({
            ...prevData,
            pronouns: contract.userData.Pronouns || "",
            relationshipStatus: contract.userData.RelationshipStatus || "",
            assignedSex: contract.userData.Gender || "",
            healthPlans: Array.isArray(contract.userData.WhyHere)
            ? contract.userData.WhyHere.filter((item) => item.trim() !== "I'm here to learn") // Filter out "I'm here to learn"
            : contract.userData.WhyHere
            ? contract.userData.WhyHere.split(',')
                .map((item) => item.trim())
                .filter((item) => item !== "" && item !== "I'm here to learn") // Exclude empty strings and "I'm here to learn"
            : [],
            familyGoals: Array.isArray(contract.userData.Goal)
                ? contract.userData.Goal
                : contract.userData.Goal
                ? contract.userData.Goal.split(',').map((item) => item.trim()).filter((item) => item !== "")
                : [],
            journeyStage: contract.userData.JourneyStatus || ""
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return; // Prevent multiple submissions
        if (!validateStep()) return;
        setIsSubmitting(true); // Set submitting state to true
        const params = {
            Company: "",
            Country: "",
            MemberID: "",
            WhyHere: "",
            EmailID: "",
            Language: "",
            Version: "10.8",
            WINBenefits: "",
            LastName: "",
            ZipCode: "",
            Promocode: "",
            Pronouns: "",
            UpdateFlag: "",
            PWD: "",
            JourneyStatus: "",
            HealthPlanId: "",
            PreferredName: "",
            RelationshipStatus: "",
            IsHealthProfileCompleted: 1,
            BenefitProvider: "",
            SubscriberID: "",
            Gender: "",
            Contract: "",
            DOB: "",
            AppLanguage: "English",
            DeviceType: "PatientPortal",
            PhoneNo: "",
            Ethnicity: "",
            SecureCode: "",
            Goal: "",
            CountryCode: "",
            TextNotificationStatus: "",
            FirstName: "",
            PregnancyDueDate:"",
            WinCentivekit:"N",
           WinCentiveAddress:"",
           NoDueDateFlag:"",
           LastMenstrualPeriodDate:"",
           IsPregnant:"",
           Weight:"",
           TypeofWeigh:"",
           Height:"",
           TypeofHeight:""

        };
        if (step >= 1) {
            params.EmailID = isEditMode ? editUserData.EmailID || "" : verifyData.EmailID || "";
            params.Pronouns = formData.pronouns || "";
            params.RelationshipStatus = formData.relationshipStatus || "";
        }
        if (step >= 2) {
            params.Gender = formData.assignedSex || "";
        }
        if (step >= 3) {
            params.WhyHere = Array.isArray(formData.healthPlans) ? formData.healthPlans.join(", ") : formData.healthPlans || "";
        }
        if (step >= 5) {
            params.Goal = formData.familyGoals.join(', ') || "";
        }
        if (step >= 6) {
            params.JourneyStatus = t(formData.journeyStage) || "";
        }
        if (step >= 7) {
            
            params.WinCentivekit = formData.WinCentivekit || "";
            params.IsPregnant=formData.IsPregnant||"";
            params.NoDueDateFlag=formData.NoDueDateFlag ||"";
            params.LastMenstrualPeriodDate=formData.LastMenstrualPeriodDate ||""
        }
        if(step>=8)
        {
params.PregnancyDueDate = formData.PregnancyDueDate || "";
            params. WinCentiveAddress = formData.WinCentiveAddress || "";
        }
        if(step>=9)
        {
            params.Weight=formData.Weight
            params.TypeofWeigh=formData.TypeofWeigh
            params.Height=formData.Height
            params.TypeofHeight=formData.TypeofHeight
        }
        if (formData.BabyCount) {
          debugger
            params.BabyCount = formData.BabyCount;
        }

        if (isEditMode) {
            params.Country = editUserData.Country || "";
            params.MemberID = editUserData.MemberID || "";
            params.Language = editUserData.Language || "";
            params.Contract = editUserData.Contract || editUserData.ContractIdentified || "";
            params.WINBenefits = "Y";
            params.LastName = editUserData.LastName || "";
            params.ZipCode = editUserData.ZipCode || "";
            params.Promocode = editUserData.Promocode || editUserData.EmployerCode;
            params.UpdateFlag = "Y";
            params.PWD = editUserData.PWD || "";
            params.PreferredName = editUserData.PreferredName || "";
            params.BenefitProvider = editUserData.BenefitProvider || "";
            params.Contract = editUserData.Contract || editUserData.ContractIdentified || "";
            params.DOB = editUserData.DOB || "";
            params.DeviceType = "PatientPortal";
            params.PhoneNo = editUserData.PhoneNo || editUserData.MobileNumber || "";
            params.Ethnicity = editUserData.Ethnicity || "";
            params.SecureCode = editUserData.SecureCode || "";
            params.CountryCode = editUserData.CountryCode || "";
            params.TextNotificationStatus = editUserData.TextNotificationStatus || "";
            params.FirstName = editUserData.FirstName || "";
        } else {
            params.Company = verifyData.Company || "";
            params.Country = verifyData.Country || "";
            params.MemberID = verifyData.MemberID || "";
            params.Language = verifyData.Language || "";
            params.WINBenefits = verifyData.WINBenefits || "N";
            params.LastName = verifyData.LastName || "";
            params.ZipCode = verifyData.ZipCode || "";
            params.Promocode = verifyData.Promocode || "";
            params.UpdateFlag = verifyData.UpdateFlag || "N";
            params.PWD = verifyData.PWD || "";
            params.PreferredName = verifyData.PreferredName || "";
            params.HealthPlanId = verifyData.HealthPlanId || "";
            params.SubscriberID = verifyData.SubscriberID || "";
            params.Contract = verifyData.Contract || verifyData.ContractIdentified || "";
            params.DOB = verifyData.DOB || "";
            params.DeviceType =  "PatientPortal";
            params.PhoneNo = verifyData.PhoneNo || verifyData.MobileNumber || "";
            params.Ethnicity = verifyData.Ethnicity || "";
            params.SecureCode = verifyData.SecureCode || "";
            params.CountryCode = verifyData.CountryCode || "";
            params.TextNotificationStatus = verifyData.TextNotificationStatus || "N";
            params.FirstName = verifyData.FirstName || "";
        }
        // const updatedUserData = {
        //     ...editUserData,
        //     Pronouns: formData.pronouns,
        //     RelationshipStatus: formData.relationshipStatus,
        //     Gender: formData.assignedSex,
        //     WhyHere: formData.healthPlans.join(', '),
        //     Goal: formData.familyGoals.join(', '),
        //     JourneyStatus: formData.journeyStage
        //   };
        
        //   // Optimistically update local state and Redux store
        //   setEditUserData(updatedUserData);
        //   dispatch({
        //     type: 'UPDATE_USER_DATA',
        //     payload: updatedUserData
        //   });
        try {
          const paramsObject ={
            ...params,
                EmployeeID: "",
                EmployeeFirstName: "",
                EmployeeLastName: "",
                RelationshiptoEmployee: ""
          }
            const response = await axios.post(
                Endpoints.CreateAccount,
                `_Params=${encodeURIComponent(JSON.stringify(paramsObject))}`,
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    }
                }
            );
            if (response.data.Result === 2) {
                SavepreconceptionDetails();
                const Ethnicity = response.data.Ethnicity;
                const WhyHere = response.data.WhyHere;

                    if (isEditMode) {
                        const updatedUserData = {
                            ...response.data,
                            Pronouns: formData.pronouns,
                            RelationshipStatus: formData.relationshipStatus,
                            Gender: formData.assignedSex,
                            WhyHere: formData.healthPlans,
                            Goal: formData.familyGoals.join(', '),
                            JourneyStatus: formData.journeyStage,
                          };
                        dispatch(updateEmail(editUserData.EmailID));
                        dispatch(setRegistrationData(updatedUserData));
                        dispatch(updateUserData(updatedUserData));
                          setEditUserData(updatedUserData);
                          setFormData((prevData) => ({
                            ...prevData,
                            pronouns: response.data.Pronouns || "",
                            relationshipStatus: response.data.RelationshipStatus || "",
                            assignedSex: response.data.Gender || "",
                            healthPlans: Array.isArray(response.data.WhyHere) ? response.data.WhyHere : response.data.WhyHere ? response.data.WhyHere.split(',').map((item) => item.trim()).filter((item) => item !== "") : [],
                            familyGoals: Array.isArray(response.data.Goal) ? response.data.Goal : response.data.Goal ? response.data.Goal.split(',').map((item) => item.trim()).filter((item) => item !== "") : [],
                            journeyStage: response.data.JourneyStatus || ""
                          }));
                        
                        toast.success(t('profileupdatedsucessfully'), { autoClose: 5000 });
                         }
                         if (!isEditMode) {
                          console.log("Creating account for new user...", ssoId, ssoParams);                            // Fetch the token only in non-edit mode
                            let token = isSSO ? await validateSSOUser(ssoId, ssoParams) : await getTokenId(); 
                            console.log("Token after validation:", token);
                            debugger
                            if (token) {
                              console.log("Obtained Token:", token);
                                // Set token in cookies and localStorage
                                cookies.set('AccessToken', token, { path: '/' });
                                localStorage.setItem('AccessToken', token);
                                
                                // Initialize session expiration
                                const expirationTime = Date.now() + 15 * 60 * 1000; // 15 minutes
                                localStorage.setItem('sessionExpiration', expirationTime.toString());
                                localStorage.removeItem('sessionExpired'); // Clear any existing expired flag
                                
                                // Update Redux state
                                dispatch({ type: 'LOGIN_SUCCESS', payload: token });
                                dispatch(setFullyVerified());
                                dispatch(setRegistrationData(response.data));
                                dispatch(updateUserData(response.data));
                                dispatch(updateEmail(verifyData.EmailID));
                            }
                            toast.success(t('profilesavedsucessfully'), { autoClose: 5000 });
                        }
                            // Reset header menu state before navigating home
                    window.dispatchEvent(new Event("resetHeaderMenu"));
                    setTimeout(() => {
                        navigate(
                          (formData.healthPlans === 'I want gender affirming support' && !isEditMode) ? 
                          "/welcome" : "/home", { state: { Ethnicity, WhyHere } }
                        );
                    }, 3000);
            } else {
                toast.error(`Account creation failed: ${response.data.Message || "Unknown error"}`, { autoClose: 2000 });
            }
        } catch (error) {
            toast.error(`Error creating account: ${error.response?.data?.Message || error.message}`, { autoClose: 2000 });
            setIsSubmitting(false);
          }
    };
 
    const SavepreconceptionDetails = async () => {
           // Call SavePreconception API if on last step and all required fields exist
        if (step === 9 && formData.healthPlans && (Array.isArray(formData.healthPlans) ? formData.healthPlans[0] : formData.healthPlans) === t('pregnancysupport')) {
        try {
            const params = {
                Emailid: isEditMode ? editUserData.EmailID || "" : verifyData.EmailID || "",
                Ava: formData.Ava || 'N',
                Mira: formData.Mira || 'N',
                WINFertilityTracker: formData.WINFertilityTracker || 'N',
                Natural: formData.Natural || 'N',
                FertilityTreatment: formData.FertilityTreatment || 'N',
                DeviceType: 'PatientPortal',
            };

            const response = await axios.post(
                Endpoints.SavePreconception,
                `_Params=${encodeURIComponent(JSON.stringify(params))}`,
                {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }
            );
            if (response.status== 200) {
               console.log(response.data);
                return;
            }
        } catch (error) {
            toast.error(`Error saving preconception: ${error.response?.data?.Message || error.message}`, { autoClose: 2000 });
            setIsSubmitting(false);
            return;
        }

        }
    }
    const validateSSOUser = async (ssoId, ssoParams) => {
      console.log("Validating SSO user with ID and Params:", ssoId, ssoParams);
      // If ssoId or ssoParams are missing, get them from sessionStorage
  if (!ssoId || !ssoParams) {
    ssoId = sessionStorage.getItem("ssoId");
    ssoParams = sessionStorage.getItem("ssoParams");
  }
    
      debugger
        try {
          const params = {
            SSO_ID: ssoId,
            SSO_PARAMS: ssoParams,
          };
      
          const response = await axios.post(
            Endpoints.ValidateSSO,
            `_Params=${encodeURIComponent(JSON.stringify(params))}`,
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
          );
      console.log("SSO Validation Response:", response.data);
      debugger
          if (response.data!=null) {
            const token = response.data?.Token;
            return token;
          }
        } catch (error) {
        }
      };
                    
    const getTokenId = async () => {
        const emailId = verifyData.EmailID;
        try {
            const response = await axios.post(
                Endpoints.GET_Token,
                `Password=${encodeURIComponent(verifyData.PWD)}&UserName=${encodeURIComponent(emailId)}`,
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    }
                }
            );

            if (response.data?.Token?.TokenId) {
                const token = response.data.Token.TokenId;
                cookies.set('AccessToken', token, { path: '/' });
                localStorage.setItem('AccessToken', token);
                return token;
            } else {
                toast.error("unable to get the token", { autoClose: 2000 });
            }
        } catch (error) {
            toast.error("unable to get the token", { autoClose: 2000 });
        }
    };

    // const GetEncryptedPassword = (password) => {
    //     const SECRET_KEY = 'winpatientportal';
    //      return CryptoJS.AES.encrypt(password, SECRET_KEY).toString();
    //            };
// const GetDecryptPassword=(encryptedPassword)=>
// {
//     const SECRET_KEY = 'winpatientportal';
//         const bytes = CryptoJS.AES.decrypt(encryptedPassword, SECRET_KEY);
//         return bytes.toString(CryptoJS.enc.Utf8);
// }
    const isLastStep = step === 6 || (step === 4 && !formData.healthPlans==='I want family-building support') || (step === 4 && !formData.healthPlans===t('pregnancysupport') ||  step === 8);

    useEffect(() => {
      const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
      
      if (myCarousel) {
          new window.bootstrap.Carousel(myCarousel, {
            interval: 5000, // Set interval in milliseconds
          });
        }
    }, []);

    return (
        <>
            {!isEditMode && (
                <header>
                    <nav className="navbar navbar-expand-lg container-fixed">
                        <a className="navbar-brand" href="#">
                              {isHighmarkPortal ? 
            <img src={highmarkLogo} alt="Logo" className="logo brand-logo" />
          : 
            <img src={logo} alt="Logo" className="logo brand-logo" />
          } 
                        </a>
                    </nav>
                </header>
            )}

            <div className="profile-setup-block-main">
                <div className="registration-image-wrapper">
                    <div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                                <img src={loginImage01} alt="" className="registration-image" />
                            </div>
                            <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                                <img src={loginImage02} alt="" className="registration-image" />
                            </div>
                            <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                                <img src={loginImage03} alt="" className="registration-image" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="registration-form-main">
                    <div className="registration-form">
                        <div className="registration-process-form-wrapper">
                        <form onSubmit={handleSubmit}>
  {step === 1 && (
    <Pronouns
      nextStep={nextStep}
      handleChange={handleChange}
      formData={formData}
      error={errors.pronouns}
      step={getCurrentStepNumber()}
      totalSteps={getTotalSteps()}
      isHighmarkPortal={isHighmarkPortal}
    />
  )}
  {step === 2 && (
    <Relationship
      nextStep={nextStep}
      prevStep={prevStep}
      handleChange={handleChange}
      formData={formData}
      error={errors.relationshipStatus}
      step={getCurrentStepNumber()}
      totalSteps={getTotalSteps()}
      isHighmarkPortal={isHighmarkPortal}
    />
  )}
  {step === 3 && (
    <Gender
      nextStep={nextStep}
      prevStep={prevStep}
      handleChange={handleChange}
      formData={formData}
      error={errors.assignedSex}
      step={getCurrentStepNumber()}
      totalSteps={getTotalSteps()}
      isHighmarkPortal={isHighmarkPortal}
    />
  )}
  {step === 4 && (
    <HealthPlan
      nextStep={nextStep}
      prevStep={prevStep}
      formData={formData}
      setFormData={setFormData}
      handleSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      error={errors.healthPlans}
      emailid={isEditMode ? editUserData.EmailID : verifyData.EmailID}
      setErrors={setErrors}
      isEdit={isEditMode}
      step={getCurrentStepNumber()}
      totalSteps={getTotalSteps()}
      isHighmarkPortal={isHighmarkPortal}
    />
  )}
  {step === 5 && (
    <FamilyBuildingGoals
      nextStep={nextStep}
      prevStep={prevStep}
      handleChange={handleChange}
      formData={formData}
      error={errors.familyGoals}
      step={getCurrentStepNumber()}
      totalSteps={getTotalSteps()}
      isHighmarkPortal={isHighmarkPortal}
    />
  )}
  {step === 6 && (
    <FamilyBuildingJourney
      prevStep={prevStep}
      handleSubmit={handleSubmit}
      handleChange={handleChange}
      formData={formData}
      isLastStep={isLastStep}
      isSubmitting={isSubmitting}
      error={errors.journeyStage}
      step={getCurrentStepNumber()}
      totalSteps={getTotalSteps()}
      isHighmarkPortal={isHighmarkPortal}
    />
  )}
  {step === 8 && (
    <PregnancyDueDate
      nextStep={nextStep}
      prevStep={prevStep}
      formData={formData}
      setFormData={setFormData}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      isLastStep={isLastStep}
      creationData={verifyData}
      error={errors.pregnancyDueDate || errors.addressOption || errors.WinCentiveAddress || errors.pregnancyType}
      setErrors={setErrors}
      step={getCurrentStepNumber()}
      totalSteps={getTotalSteps()}
      isHighmarkPortal={isHighmarkPortal}
    />
  )}
  {step === 9 && (
    <WelcomeKit
      nextStep={nextStep}
      prevStep={prevStep}
      formData={formData}
      setFormData={setFormData}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      isLastStep={isLastStep}
      creationData={verifyData}
      error={ errors.addressOption || errors.WinCentiveAddress }
      setErrors={setErrors}
      step={getCurrentStepNumber()}
      totalSteps={getTotalSteps()}
      isHighmarkPortal={isHighmarkPortal}
    />
  )}
  {step === 7 && (
    <HowToGetPregnant
      nextStep={nextStep}
      prevStep={prevStep}
      formData={formData}
      setFormData={setFormData}
      handleChange={handleChange}
       error={errors}
      setErrors={setErrors}
      step={getCurrentStepNumber()}
      totalSteps={getTotalSteps()}
      isHighmarkPortal={isHighmarkPortal}
    />
  )}
  {step === 10 && (
    <PrepregnancyDetails
      prevStep={prevStep}
      formData={formData}
      handleChange={handleChange}
      setFormData={setFormData}
      isSubmitting={isSubmitting}
      isLastStep={isLastStep}
      handleSubmit={handleSubmit}
      error={errors}
      setErrors={setErrors}
      step={getCurrentStepNumber()}
      totalSteps={getTotalSteps()}
      isHighmarkPortal={isHighmarkPortal}
    />
  )}
</form>

                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer /> {/* For showing toast notifications */}
        </>
    );
};

export default HealthProfileMultiStageForm;
